import { render, staticRenderFns } from "./RankTable.vue?vue&type=template&id=2c63a8ae&scoped=true&"
import script from "./RankTable.vue?vue&type=script&lang=js&"
export * from "./RankTable.vue?vue&type=script&lang=js&"
import style0 from "./RankTable.vue?vue&type=style&index=0&id=2c63a8ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c63a8ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VCol,VRow,VSimpleTable})
